import React, { useEffect, useRef, useState } from "react";
import jsQR from "jsqr";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Camera, Keyboard } from "lucide-react";

// Camera QR scanner (jsQR). Calls onCode(text) once per distinct code; manual Member ID entry as fallback.
export default function QrScanner({ onCode, active = true }) {
  const videoRef = useRef(); const canvasRef = useRef(); const lastRef = useRef({ code: "", at: 0 });
  const [err, setErr] = useState("");
  const [manual, setManual] = useState("");

  useEffect(() => {
    if (!active) return;
    let stream; let raf; let stop = false;
    const tick = () => {
      if (stop) return;
      const v = videoRef.current; const c = canvasRef.current;
      if (v && c && v.readyState === v.HAVE_ENOUGH_DATA) {
        c.width = v.videoWidth; c.height = v.videoHeight;
        const ctx = c.getContext("2d", { willReadFrequently: true });
        ctx.drawImage(v, 0, 0, c.width, c.height);
        const img = ctx.getImageData(0, 0, c.width, c.height);
        const q = jsQR(img.data, img.width, img.height, { inversionAttempts: "dontInvert" });
        if (q?.data) {
          const now = Date.now();
          if (q.data !== lastRef.current.code || now - lastRef.current.at > 4000) { lastRef.current = { code: q.data, at: now }; onCode(q.data); }
        }
      }
      raf = requestAnimationFrame(tick);
    };
    navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } })
      .then((s) => { stream = s; if (videoRef.current) { videoRef.current.srcObject = s; videoRef.current.play().catch(() => {}); } tick(); })
      .catch(() => setErr("Camera unavailable — type the Member ID below instead."));
    return () => { stop = true; cancelAnimationFrame(raf); stream?.getTracks().forEach((t) => t.stop()); };
  }, [active, onCode]);

  return (
    <div data-testid="qr-scanner">
      <div className="relative overflow-hidden rounded-xl bg-black">
        <video ref={videoRef} className="aspect-video w-full object-cover" muted playsInline />
        <canvas ref={canvasRef} className="hidden" />
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center"><div className="h-48 w-48 rounded-2xl border-4 border-[hsl(var(--gold))]/80 shadow-[0_0_0_9999px_rgba(0,0,0,0.35)]" /></div>
        {err && <p className="absolute inset-x-0 bottom-0 bg-black/70 p-2 text-center text-xs text-white" data-testid="qr-error">{err}</p>}
        {!err && <p className="absolute inset-x-0 bottom-0 flex items-center justify-center gap-1 bg-black/50 p-1.5 text-xs text-white"><Camera className="h-3.5 w-3.5" />Point the camera at the brother's ID card QR</p>}
      </div>
      <form className="mt-3 flex gap-2" onSubmit={(e) => { e.preventDefault(); if (manual.trim()) { onCode(manual.trim().toUpperCase()); setManual(""); } }}>
        <div className="relative flex-1"><Keyboard className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" /><Input value={manual} onChange={(e) => setManual(e.target.value)} placeholder="or type Member ID e.g. BAN-IG-26-0001" className="pl-9 font-mono-data uppercase" data-testid="qr-manual-input" /></div>
        <Button type="submit" variant="outline" className="gold-ring" data-testid="qr-manual-submit">Check</Button>
      </form>
    </div>
  );
}
